import React from "react";
import Topbar from "../Topbar";
import ImgHeader from "./ImgHeader";
import Banner1 from "./Banner1";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Banner2 from "./Banner2";
import BannerImg from "../BannerImg";
import Footer from "../Footer";
import { Container } from "react-bootstrap";
import BG from "../../assets/Images/BG.jpg";
import SEO from "../SEO";

export default function Blog2() {
  // Structured data for Blog2 - Paint and color psychology
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: "The Power of Paint: How Colors Transform Interior Spaces",
    description:
      "Paint can entirely change the atmosphere of the interior and create harmony with the décor by your style. Each tone of color has a significant effect on our mood, has a specific meaning, and interlinks with our mind frame. Colors have the power to change your mood and mind.",
    url: "https://kritikagoswamymalik.com/blog2",
    datePublished: "2024-12-26T10:00:00+00:00",
    dateModified: "2024-12-26T10:00:00+00:00",
    author: {
      "@type": "Person",
      name: "Kritika Goswamy Malik",
      jobTitle: "Interior Designer",
      url: "https://kritikagoswamymalik.com/about",
    },
    publisher: {
      "@type": "Organization",
      name: "KGM Interiors",
      url: "https://kritikagoswamymalik.com/",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://kritikagoswamymalik.com/blog2",
    },
    articleSection: "Interior Design",
    keywords: [
      "paint colors",
      "color psychology",
      "interior atmosphere",
      "mood and color",
      "color meaning",
      "interior decoration",
      "color harmony",
    ],
    about: {
      "@type": "Thing",
      name: "Color Psychology in Interior Design",
      description:
        "How different paint colors affect mood and atmosphere in interior spaces",
    },
  };

  return (
    <>
      <SEO
        title="The Power of Paint: How Colors Transform Interior Spaces"
        description="Paint can entirely change the atmosphere of the interior and create harmony with the décor by your style. Each tone of color has a significant effect on our mood, has a specific meaning, and interlinks with our mind frame. Colors have the power to change your mood and mind."
        keywords="paint colors, color psychology, interior atmosphere, mood and color, color meaning, interior decoration, color harmony, interior design blog"
        canonicalUrl="/blog2"
        article={true}
        publishedDate="2024-12-26T10:00:00+00:00"
        modifiedDate="2024-12-26T10:00:00+00:00"
        structuredData={structuredData}
      />

      <Container
        fluid
        className="p-0"
        style={{
          backgroundColor: "#F5F5DC",
          backgroundImage: `url(${BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Topbar />
        <ImgHeader />
        <Banner1 />
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Banner2 />
        <BannerImg />
        <Footer />
      </Container>
    </>
  );
}
